import React from 'react'
import BarManagement from './BarManagement/BarManagement'
import CourseOverview from './CourseOverview/CourseOverview'
import Certificate from './CertificateSection/Certificate'
import KeyModules from './KeyModulesSection/KeyModules'
import Opportunities from './Opportunities/Opportunities'
import Choose from './WhyChoose/Choose'
import BGallery from './BarGallery/BGallery'

function Bar() {
  return (
    <>
      <BarManagement/>
      <CourseOverview/>
      <Certificate/>
      <KeyModules/>
      <Opportunities/>
      <Choose/>
      <BGallery/>
    </>
  )
}

export default Bar
